import { render, staticRenderFns } from "./CreatePointByRevenue.vue?vue&type=template&id=683bede8&scoped=true&"
import script from "./CreatePointByRevenue.vue?vue&type=script&lang=js&"
export * from "./CreatePointByRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683bede8",
  null
  
)

export default component.exports